<template>
  <div class="profile-block profile-workplace">
    <template v-if="place">
      <div class="profile-block__title">
        {{ $t('labels.work_place') }}
        <span v-if="index > 0">{{ index + 1}}</span>
      </div>
      <div class="profile-block__row profile-workplace__row profile-workplace__row--place" :style="{ minHeight: workplaceRowHeights.place + 'px'}">
        <div class="profile-block__row-label">{{ $t('labels.place') }}</div>
        <div class="profile-block__row-data">
          <dep-name :orgId="place.org_id" :showParent="true" orgLinkName="orgPage"></dep-name>
        </div>
      </div>

      <div v-if="isChief" class="profile-block__row">
        <div class="profile-block__row-label">{{ $t('labels.management') }}</div>
        <div class="profile-block__row-data">
          <span class="profile-workplace__chief">{{ $t('labels.department_head') }}</span>
        </div>
      </div>

      <div class="profile-block__row profile-workplace__row profile-workplace__row--occupation" :style="{ minHeight: workplaceRowHeights.occupation + 'px'}">
        <div class="profile-block__row-label">{{ $t('labels.position') }}</div>
        <div class="profile-block__row-data">
          {{place.note ? place.note : $t('labels.not_specified')}}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="profile-block__title">{{ $t('labels.work_place') }}</div>{{ $t('labels.not_specified') }}
    </template>
  </div>
</template>
<script>
  import depName from 'src/components/Orgs/OrgName.vue'
  import PostsInRow from 'src/components/Users/PostsInRow.vue'

  export default {
    props: ['place', 'index', 'userId', 'workplaceRowHeights'],
    components: {
      depName,
      PostsInRow
    },
    data () {
      return {
        isChief: false
      }
    },
    computed: {
      isOutpatient () {
        return this.place.public
      }
    },
    methods: {
      isDoctor (workplace) {
        return workplace.roles.some(function (element) {
          return element === 'doctor' || element === 'admin'
        })
      },
      getRolesNames (values) {
        let names = roles.getRolesName(values)
        return names
      },
      statusInText (status) {
        let name = statusList.getStatusName(status)
        return name;
      },
      async isOrgChief () {
        /* await org.get(this.place.org_id).then(data => {
          if (this.userId === data.org.blocks.info.chief.val) {
            this.isChief = true;
          }
        }) */
      }
    },
    async mounted () {
      if (this.place) {
        this.isOrgChief()
      }
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/paper/variables';

  .profile-block {
    &.profile-workplace {
      position: relative;
      display: flex;
      flex-direction: column;
      margin-bottom: 0;
      border-radius: 0;
      box-shadow: none;
      border-left: 1px solid $light-border-color;
      border-bottom: 1px solid $light-border-color;

      .profile-workplace__status {
        margin-top: auto;
      }

      &:first-child {
        &:before {
          background: #8099f5;
        }
      }
    }
    &__row {
      &--outpatient {
        // margin-bottom: 40px;
      }

      a {
        color: inherit;
      }
    }
  }

  .profile-workplace {
    &__chief {
      color: #52b12d;
    }
    &__status {
      span {
        border-radius: 4px;
        padding: 10px 15px;
        background: #fdf2e6;
        color: #df8c2f;
      }

      &.active {
        span {
          background: #ecf7e5;
          color: #52b12d;
        }
      }
    }
  }

  @media (max-width: 1199px) {
    .profile-workplace__row {
      min-height: auto !important;
    }
  }
</style>